import { render, staticRenderFns } from "./HeadlinePriceModal.vue?vue&type=template&id=a4a385fe&"
import script from "./HeadlinePriceModal.vue?vue&type=script&lang=js&"
export * from "./HeadlinePriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports